module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "room-properties"
  }, [_c('auto-table', {
    attrs: {
      "defines": _vm.$defines.property,
      "unstackable": "unstackable",
      "compact": _vm.compact,
      "pagesize": _vm.pagesize,
      "data": _vm.room_properties,
      "layout": "room"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee6615f4","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/mixed/RoomProperties.vue
// module id = 386
// module chunks = 0